import { ClaimType } from '@constants';
import { useSelector } from 'react-redux';
import { PageTitle, BottomButtons } from '@components';
import ChooseItem from './components/choose-Item';
import ChooseItemDamage from './components/choose-item-damage';
import classes from './index.module.css';
import { useChooseItems } from './hooks';
import { ReasonDialog } from './components/reason-dialog';

const TITLE_TEXT = {
  [ClaimType.Theft]: 'Please choose which item(s) are in this package',
  [ClaimType.Damage]: 'Please choose which item(s) are damaged.',
  [ClaimType.Loss]: 'Please choose which item(s) are in this package',
};

export default function ChooseItems() {
  const { type, dhgateItems } = useSelector((state) => state.claim);

  const {
    isBtnDisable,
    open,
    selectedDhgateItems,
    onChange,
    willChecked,
    handleChange,
    handleClose,
    handleOK,
    dialogReasonChange,
    commentsChange,
    handleItemEdit,
    onClickContinue,
    onClickBack,
  } = useChooseItems();

  const ChoosePageMap = (item) => {
    const selectedInfo = selectedDhgateItems[item.lineItemId] || {};
    return {
      [ClaimType.Theft]: <ChooseItem item={item} quantity={selectedInfo.quantity} onChange={onChange} />,
      [ClaimType.Damage]: <ChooseItemDamage item={item} selectedInfo={selectedInfo} handleCheckboxChange={handleChange} onClick={handleItemEdit} />,
      [ClaimType.Loss]: <ChooseItem item={item} quantity={selectedInfo.quantity} onChange={onChange} />,
    };
  };

  return (
    <div className={classes.content}>
      <PageTitle title="Protected item(s)" subTitle={TITLE_TEXT[type]} />
      {dhgateItems.map((item, index) => (
        <div key={item.lineItemId}>{ChoosePageMap(item, index)[type || ClaimType.Damage]}</div>
      ))}

      <BottomButtons
        isContinueDisabled={isBtnDisable}
        onClickContinue={onClickContinue}
        onClickBack={onClickBack}
      // isContinueLoading={isLoading}
      />
      {open && (
        <ReasonDialog
          open={open}
          selectedDhgateItems={selectedDhgateItems}
          handleClose={handleClose}
          handleOK={handleOK}
          onRadioChange={dialogReasonChange}
          onCommentsChange={commentsChange}
          currentItem={willChecked}
        />
      )}
    </div>

  );
}
